import {
  HIDE_MESSAGE,
  INIT_URL,
  ON_HIDE_LOADER,
  ON_SHOW_LOADER,
  SHOW_MESSAGE,
  SIGNIN_USER_SUCCESS,
  SIGNOUT_USER_SUCCESS,
  USER_DATA,
  USER_DATA_SUCCESS,
  USER_TOKEN_SET,
  USER_REFRESH_TOKEN_SET,
  SIGNOUT_USER_BY_TIMEOUT,
  CHANGE_PASSWORD_SUCCESS,
  RESET_PASSWORD_SUCCESS,
  RESET_PASSWORD_FAIL,
  RESET_PASSWORD_SET_INITIAL_VALUES,
  CONFIRM_EMAIL_FAIL,
  CONFIRM_EMAIL_SUCCESS,
  CONFIRM_EMAIL_REINIT_STATE,
  REGISTER_USER_FAIL,
  REGISTER_USER_SUCCESS,
  MASQUERADE_ADMIN_USER_TOKEN_SET,
  MASQUERADE_ADMIN_USER_REFRESH_TOKEN_SET,
  MASQUERADE_QUIT_RESTORE_TOKENS,
  TOKENOFADMINDURINMASQUERADE_SET,
  REFRESHTOKENOFADMINDURINMASQUERADE_SET,
  MASQUERADE_SUCCESS,
  MASQUERADE,
  MFA_REGISTER,
  MFA_REGISTER_SUCCESS,
  MFA_REGISTER_FAIL,
  MFA_REGISTER_DELETE,
  MFA_REGISTER_DELETE_SUCCESS,
  MFA_REGISTER_DELETE_FAIL,
  MFA_SESSION_TOKEN_SET,
  MFA_VERIFY_SUCCESS,
  MFA_VERIFY_FAIL,
  MFA_VERIFY,
  MFA_RESET_REGISTRATION_FORM,
  MFA_CLOSE_REGISTRATION_FORM,
  MFA_SET_LOGIN_META,
  MFA_SEND_ALT_CODE,
  MFA_SEND_ALT_CODE_SUCCESS,
  MFA_SEND_ALT_CODE_FAIL,
  ADD_TAG_SUCCESS_AUTH_USER,
  ADD_TAG_FAIL_AUTH_USER,
  UPDATE_TAG_SUCCESS_AUTH_USER,
  FETCH_AUTH_USER_DATA,
  FETCH_AUTH_USER_DATA_SUCCESS,
  FETCH_AUTH_USER_DATA_FAIL,
  ADD_NEW_USER_SELF_MANAGED,
  ADD_NEW_USER_SELF_MANAGED_SUCCESS,
  ADD_NEW_USER_SELF_MANAGED_FAIL,
  FETCH_NEW_COMPANY,
  FETCH_NEW_COMPANY_SUCCESS,
  FETCH_NEW_COMPANY_FAIL,
  ADD_NEW_COMPANY,
  ADD_NEW_COMPANY_SUCCESS,
  ADD_NEW_COMPANY_FAIL,
  MANUAL_TOKEN_REFRESH,
  MANUAL_TOKEN_REFRESH_FAIL,
  MANUAL_TOKEN_REFRESH_SUCCESS,
  INITIATE_PRODUCT_TOUR_FOR_PAGE,
  INITIATE_PRODUCT_TOUR_FOR_PAGE_SUCCESS,
  INITIATE_PRODUCT_TOUR_FOR_PAGE_FAIL,
} from "constants/ActionTypes";
import {CHANGE_PASSWORD_FAIL} from "../constants/ActionTypes";
import {createLocalUserData} from "../sagas/Auth";
// import React from "react";

const INIT_STATE = {
  token: JSON.parse(localStorage.getItem('token')),
  //token: null,
  refreshToken: JSON.parse(localStorage.getItem('refreshToken')),
  tokenOfAdminDuringMasquerade: JSON.parse(localStorage.getItem('tokenOfAdminDuringMasquerade')),
  refreshTokenOfAdminDuringMasquerade: JSON.parse(localStorage.getItem('refreshTokenOfAdminDuringMasquerade')),
  mfaSessionToken: JSON.parse(localStorage.getItem('mfaSessionToken')),
  initURL: '',
  alertMessage: '',
  showMessage: false,
  loader: false,
  authUser: JSON.parse(localStorage.getItem('authUser')),
  hasGetUserBeenCalledAtLeastOnce: null,
  loadingAuthUser: false,
  loadingAuthUserError: false,
  //authUser: null,
  loadingMasquerade: false,
  loadingManualTokenRefresh: false,
  errorLoadingManualTokenRefresh: false,
  loadingMFARegister: false,
  loadingMFARegisterDelete: false,
  mfaRegisterError: false,
  mfaRegisterDeleteError: false,
  loadingMFAVerify: false,
  mfaVerifyError: false,
  mfaLoginMeta: null,
  loadingMFASendAltCode: false,
  loadingMFASendAltCodeFail: false,
  mfaAltCodeUserMessage: null,
  entityToConfirm: null,
  errorWithEntityToConfirm: null,
  errorMessage: null,
  loadingAddNewCustomer: false,
  errorLoadingAddNewCustomer: false,
  loadingFetchNewCompany: false,
  // loadingSubscriptions: false,
  // errorLoadingSubscriptions: false,
  startProductTour: null,
  loadingStartProductTour: false,
  startProductTourError: false,
  appMisc: {
    didJustResetPW: false,
    didJustEmailConfirmCode: null,
    didJustRegisterUser: null,
    didJustMasquerade: null,
    didJustRegisterForMFA: null,
    mfaOtpQrcodeUrl: null,
    mfaFormStatus: null,
    mfaFormUserMessage: null,
    didJustVerifyForMFA: null,
    didJustDisableMFA: null,
    closeMFAForm: null,
    didJustRegisterCompany: null,
    didJustAddTourTag: {},
  }

};

export default (state = INIT_STATE, action) => {
  switch (action.type) {


    case INIT_URL: {
      return {...state, initURL: action.payload};
    }

    case SIGNOUT_USER_BY_TIMEOUT:
    case SIGNOUT_USER_SUCCESS: {
      return {
        ...INIT_STATE,
        token: null,
        refreshToken: null,
        authUser: null,
        tokenOfAdminDuringMasquerade: null,
        refreshTokenOfAdminDuringMasquerade: null,
        mfaSessionToken: null,
        mfaAltCodeUserMessage: null,
        mfaLoginMeta: null,
      }
    }

    case CONFIRM_EMAIL_FAIL:
      return {
        ...state,
        loader: false,
        appMisc: {
          ...state.appMisc,
          didJustEmailConfirmCode: false
        },
    }

    case CONFIRM_EMAIL_SUCCESS:
      return {
        ...state,
        loader: false,
        appMisc: {
          ...state.appMisc,
          didJustEmailConfirmCode: true
        },
      }
    case REGISTER_USER_FAIL:
      return {
        ...state,
        loader: false,
        appMisc: {
          ...state.appMisc,
          didJustRegisterUser: false
        },
      }

    case REGISTER_USER_SUCCESS:
      return {
        ...state,
        loader: false,
        appMisc: {
          ...state.appMisc,
          didJustRegisterUser: true
        },
      }

    case RESET_PASSWORD_FAIL:
    case CHANGE_PASSWORD_SUCCESS:
    case CHANGE_PASSWORD_FAIL:
    case SIGNIN_USER_SUCCESS: {
      return {
        ...state,
        loader: false
      }
    }

    case RESET_PASSWORD_SUCCESS:
    {
      return {
        ...state,
        loader: false,
        appMisc: {
          ...state.appMisc,
          didJustResetPW: true
        },
      }
    }

    case RESET_PASSWORD_SET_INITIAL_VALUES:
    {
      return {
        ...state,
        appMisc: {
          ...state.appMisc,
          didJustResetPW: false
        },
      }
    }

    case CONFIRM_EMAIL_REINIT_STATE:
    {
      return {
        ...state,
        appMisc: {
          ...state.appMisc,
          didJustEmailConfirmCode: null
        },
      }
    }

    case USER_TOKEN_SET: {
      // console.log("USER_TOKEN_SET is setting the token in the state. New token:", action.payload);
      return {
        ...state,
        token: action.payload,
      };
    }

    case USER_REFRESH_TOKEN_SET: {
      // console.log("USER_REFRESH_TOKEN_SET is setting the token in the state. New refreshToken:", action.payload);
      return {
        ...state,
        refreshToken: action.payload,
      };
    }

    case USER_DATA: {
      return {
        ...state,
        authUser: action.payload,
      };
    }

    //TODO: can do when user data was updated??
    case USER_DATA_SUCCESS: {
      return {
        ...state,
        // authUser: action.payload,
      };
    }

    // case USER_TOKEN_SET: {
    //   return {
    //     ...state,
    //     token: action.payload,
    //   };
    // }

    case SHOW_MESSAGE: {
      return {
        ...state,
        alertMessage: action.payload,
        showMessage: true,
        loader: false
      }
    }
    case HIDE_MESSAGE: {
      return {
        ...state,
        alertMessage: '',
        showMessage: false,
        loader: false
      }
    }

    case ON_SHOW_LOADER: {
      return {
        ...state,
        loader: true
      }
    }
    case ON_HIDE_LOADER: {
      return {
        ...state,
        loader: false
      }
    }

    case MASQUERADE_ADMIN_USER_TOKEN_SET: {
      console.log("NOW FIRING MASQUERADE_ADMIN_USER_TOKEN_SET");
      return {
        ...state,
        tokenOfAdminDuringMasquerade: state.token,
      };
    }

    case MASQUERADE_ADMIN_USER_REFRESH_TOKEN_SET: {
      console.log("NOW FIRING MASQUERADE_ADMIN_USER_REFRESH_TOKEN_SET");
      return {
        ...state,
        refreshTokenOfAdminDuringMasquerade: state.refreshToken,
      };
    }

    case MASQUERADE_QUIT_RESTORE_TOKENS: {
      console.log("NOW FIRING MASQUERADE_QUIT_RESTORE_TOKENS");
      return {
        ...state,
        refreshToken: state.refreshTokenOfAdminDuringMasquerade,
        token: state.tokenOfAdminDuringMasquerade,
        tokenOfAdminDuringMasquerade: null,
        refreshTokenOfAdminDuringMasquerade: null
      };
    }

    case TOKENOFADMINDURINMASQUERADE_SET: {
      return {
        ...state,
        tokenOfAdminDuringMasquerade: action.payload,
      };
    }

    case REFRESHTOKENOFADMINDURINMASQUERADE_SET: {
      return {
        ...state,
        refreshTokenOfAdminDuringMasquerade: action.payload,
      };
    }

    case MASQUERADE_SUCCESS:
    {
      return {
        ...state,
        loadingMasquerade: false,
        appMisc: {
          ...state.appMisc,
          didJustMasquerade: true
        },
      }
    }

    case MASQUERADE:
    {
      return {
        ...state,
        loadingMasquerade: true,
        appMisc: {
          ...state.appMisc,
          didJustMasquerade: false
        },
      }
    }

      /***********************************
       * MANUAL_TOKEN_REFRESH
       ***********************************/
    case MANUAL_TOKEN_REFRESH:
    {
      return {
        ...state,
        loadingManualTokenRefresh: true,
        errorLoadingManualTokenRefresh: false,
      }
    }

      /***********************************
       * MANUAL_TOKEN_REFRESH_SUCCESS
       ***********************************/
    case MANUAL_TOKEN_REFRESH_SUCCESS:
    {
      return {
        ...state,
        loadingManualTokenRefresh: false,
        errorLoadingManualTokenRefresh: false,
      }
    }

      /***********************************
       * MANUAL_TOKEN_REFRESH_FAIL
       ***********************************/
    case MANUAL_TOKEN_REFRESH_FAIL:
    {
      return {
        ...state,
        loadingManualTokenRefresh: false,
        errorLoadingManualTokenRefresh: true,
      }
    }

    case MFA_REGISTER:
    {
      return {
        ...state,
        loadingMFARegister: true,
        mfaRegisterError: false,
        appMisc: {
          ...state.appMisc,
          didJustRegisterForMFA: false,
          mfaOtpQrcodeUrl: null,
          mfaFormStatus: null,
          mfaFormUserMessage: null,
        },
      }
    }

    case MFA_REGISTER_SUCCESS: {
      // {
      //   "status": "pending",
      //     "userMessage": "A verification code was sent to +16512068007 to enable multi-factor authentication.",
      //     "url": null
      // }
      const mfaRegistrationData = action.payload.inboundData
      return {
        ...state,
        loadingMFARegister: false,
        mfaRegisterError: false,
        appMisc: {
          ...state.appMisc,
          didJustRegisterForMFA: true,
          mfaOtpQrcodeUrl: mfaRegistrationData.url,
          mfaFormStatus: mfaRegistrationData.status,
          mfaFormUserMessage: mfaRegistrationData.userMessage,
        },
      }
    }

    case MFA_REGISTER_FAIL: {
      // const mfaRegistrationData = action.payload.inboundData
      return {
        ...state,
        loadingMFARegister: false,
        mfaRegisterError: true,
        appMisc: {
          ...state.appMisc,
          didJustRegisterForMFA: false,
          mfaFormUserMessage: null,
          mfaFormStatus: null,
          mfaOtpQrcodeUrl: null,
        },
      }
    }

    case MFA_REGISTER_DELETE:
    {
      return {
        ...state,
        // loadingMFARegister: true,
        // mfaRegisterError: false,
        loadingMFARegisterDelete: true,
        mfaRegisterDeleteError: false,
        // appMisc: {
        //   ...state.appMisc,
          // didJustRegisterForMFA: false,
          // mfaOtpQrcodeUrl: null,
          // mfaFormStatus: null,
          // mfaFormUserMessage: null,
        // },
      }
    }

    case MFA_REGISTER_DELETE_SUCCESS: {
      // {
      //   "status": "pending",
      //     "userMessage": "A verification code was sent to +16512068007 to enable multi-factor authentication.",
      //     "url": null
      // }
      const data = action.payload.inboundData
      let newSecurityObject = data ? data.security : null;
      const authUser = state.authUser ? state.authUser : null;

      if(!newSecurityObject) { //if doesn't exist, assume it didn't come back.
        //TODO: JOHN SHOULd send the Security object but until he does, set the authUser.security.mfa_enabled to false.

        console.warn("DEL /register call did not return a mfa security object. Fabricating one now in reducer.")

        // "security": {
        //   "mfa_enabled": true,
        //   "mfa_required": false,
        //   "mfa_preference": {
        //     "id": 1,
        //     "name": "sms",
        //     "description": "Text/SMS-based second-factor authentication."
        //   },
        //   "mfa_phone_number": "+16512068007",
        //   "mfa_email": "buster.bluth@bluth.co"
        // }

        newSecurityObject = authUser && authUser.security
            ? {
              ...authUser.security,
              mfa_enabled: false,
              mfa_required: false,
            }
            : authUser
                ? authUser.security
                : null
      } else {
        console.log("Check for mfa security object from DEL /register was found", newSecurityObject)
      }


      return {
        ...state,
        authUser: {
          ...authUser,
          security: newSecurityObject
        },

        loadingMFARegister: false,
        loadingMFARegisterDelete: false,
        mfaRegisterError: false,
        mfaRegisterDeleteError: false,
        appMisc: {
          ...state.appMisc,
          didJustRegisterForMFA: false,
          mfaOtpQrcodeUrl: null,
          mfaFormStatus: null,
          mfaFormUserMessage: data.userMessage,
          didJustDisableMFA: true,
        },
      }
    }

    case MFA_REGISTER_DELETE_FAIL: {
      // const mfaRegistrationData = action.payload.inboundData
      return {
        ...state,
        // loadingMFARegister: false,
        // mfaRegisterError: true,
        mfaRegisterDeleteError: true,
        loadingMFARegisterDelete: false,
        // appMisc: {
        //   ...state.appMisc,
        //   didJustRegisterForMFA: false,
        //   mfaFormUserMessage: null,
        //   mfaFormStatus: null,
        //   mfaOtpQrcodeUrl: null,
        // },
      }
    }

    case MFA_SESSION_TOKEN_SET: {
      //todo remove the printing of the token to the console after this is working
      console.log("NOW FIRING MFA_SESSION_TOKEN_SET", state.mfaSessionToken, action.payload);
      return {
        ...state,
        mfaSessionToken: action.payload,
        loader: false,
      };
    }

    case MFA_VERIFY:
    {
      return {
        ...state,
        loadingMFAVerify: true,
        mfaVerifyError: false,
        appMisc: {
          ...state.appMisc,
          didJustVerifyForMFA: false,
        },
      }
    }

    case MFA_VERIFY_SUCCESS: {
      // {
      //   "success": true,
      //     "userMessage": "Your account is now secured with multi-factor authentication.",
      //     "security": {
      //   "mfa_enabled": true,
      //       "mfa_required": false,
      //       "mfa_preference": {
      //     "id": 1,
      //         "name": "sms",
      //         "description": "Text/SMS-based second-factor authentication."
      //   },
      //   "mfa_phone_number": "+16512068007",
      //       "mfa_email": "buster.bluth@bluth.co"
      // }
      // }
      const data = action.payload.inboundData
      const newSecurityObject = data.security;
      return {
        ...state,
        loadingMFAVerify: false,
        mfaVerifyError: false,
        
        //overwrite the authUser security section
        authUser: {
          ...state.authUser,
          security: newSecurityObject
        },
        
        //clear out form-related data
        appMisc: {
          ...state.appMisc,
          didJustVerifyForMFA: true,
          mfaOtpQrcodeUrl: null,
          mfaFormStatus: null,
          mfaFormUserMessage: null,
        },
      }
    }

    case MFA_VERIFY_FAIL: {
      // const mfaRegistrationData = action.payload.inboundData
      return {
        ...state,
        loadingMFAVerify: false,
        mfaVerifyError: true,
        appMisc: {
          ...state.appMisc,
          didJustVerifyForMFA: false,
        },
      }
    }

    case MFA_RESET_REGISTRATION_FORM: {
      //jfd: used to totally reset the MFA form part of the state.
      return {
        ...state,
        loadingMFARegister: false,
        loadingMFARegisterDelete: false,
        mfaRegisterError: false,
        mfaRegisterDeleteError: false,
        loadingMFAVerify: false,
        mfaVerifyError: false,
        appMisc: {
          ...state.appMisc,
          didJustRegisterForMFA: null,
          mfaOtpQrcodeUrl: null,
          mfaFormStatus: null,
          mfaFormUserMessage: null,
          didJustVerifyForMFA: null,
          didJustDisableMFA: null,
          closeMFAForm: null
        }
      }
    }

    case MFA_CLOSE_REGISTRATION_FORM: {
      //jfd: used to totally reset the MFA form part of the state.
      return {
        ...state,
        appMisc: {
          ...state.appMisc,
          closeMFAForm: true
        }
      }
    }

      /*  jfd**********22.Jan.21.11:02*****
       *   Used to set secondary options and user messages after the provide a good
       *   password but need to provide MFA code
           ********************** `--===<>==<>==C>-< */
    case MFA_SET_LOGIN_META:
    {
      return {
        ...state,
        mfaLoginMeta : {
          ...action.payload
        }
      }
    }

    case MFA_SEND_ALT_CODE:
    {
      return {
        ...state,
        loadingMFASendAltCode: true,
        loadingMFASendAltCodeFail: false,
        mfaAltCodeUserMessage: null,
      }
    }

    case MFA_SEND_ALT_CODE_SUCCESS:
    {

      console.log("Sending alternative code was success. Here is returned payload", action.payload.inboundData);
      const altUserMessage = action.payload && action.payload.inboundData && action.payload.inboundData.mfa_details
          ? action.payload.inboundData.mfa_details
          : null;

      return {
        ...state,

        mfaAltCodeUserMessage: altUserMessage,

        loadingMFASendAltCode: false,
        loadingMFASendAltCodeFail: false,
      }
    }

    case MFA_SEND_ALT_CODE_FAIL:
    {
      return {
        ...state,
        loadingMFASendAltCode: false,
        loadingMFASendAltCodeFail: true,
        mfaAltCodeUserMessage: null,
      }
    }


      /***********************************
       * ADD_TAG FOR AUTHUSERS
       ***********************************/
//TODO: rename-- add_tag_success_tag-type
    case ADD_TAG_SUCCESS_AUTH_USER: {

      const customerId = action.payload.customerId
      const affectedElementId = action.payload.affectedElementId
      const newTagData = action.payload.inboundData

      console.log("Adding a new successful Tag to Local State tree.",customerId, affectedElementId, newTagData);

      // console.log("ADD_TAG_SUCCESS reducer about to put new business shares into the state. Here are the shares", newTagsData, "for these entities", entities, "for this entityId", entityId);
      console.log("state", state, state.authUser, state.authUser.user )

      const newUserTags = state.authUser
          && state.authUser.user
          && state.authUser.user.tags
              ? {
                  ...state.authUser.user.tags,
                  [newTagData.id] : newTagData
                }
              : null;

      console.log("Calculated new userTags by adding", newTagData, "Final tag sate:", newUserTags);

      const newAuthUser = {
        ...state.authUser,
        user: {
          ...state.authUser.user,
          tags: newUserTags ? newUserTags : state.authUser.user.tags

        }
      }

      //update the localStorage with this new authUser
      createLocalUserData(newAuthUser);
      console.log("updating state tree if newTag.definition.id is 61 or 61", newTagData.definition.id)

      if(newTagData.definition
          && newTagData.definition.id
          && (newTagData.definition.id === 61 || newTagData.definition.id === 62)){

        console.log("this is a tour tag so the startproducttour should be reset")
        return {
          ...state,
          authUser: newAuthUser,
          startProductTour: null,
          appMisc: {
            ...state.appMisc,
            didJustAddTourTag: {
              ...state.appMisc.didJustAddTourTag,
              [newTagData.details]: true,
            },
          }
        }
      } else{
        return {
          ...state,
          authUser: newAuthUser
        }
      }

    }

    case ADD_TAG_FAIL_AUTH_USER: {
      // const affectedElementId = action.payload.affectedElementId
      return {
        ...state,

      }
    }

  /***********************************
   * UPDATE_TAG FOR AUTHUSERS
   ***********************************/

    case UPDATE_TAG_SUCCESS_AUTH_USER: {
        const customerId = action.payload.customerId
        const affectedElementId = action.payload.affectedElementId
        const newTagData = action.payload.inboundData
        const tagId = action.payload.tagId

        console.log("updating a user tag to local state tree",customerId, affectedElementId, newTagData);

      const newAuthUser = {
        ...state.authUser,
        user: {
          ...state.authUser.user,
          tags: {
            ...state.authUser.user.tags,
            [tagId] : newTagData
          }
        }
      }

      //update the localStorage with this new authUser
      createLocalUserData(newAuthUser);

      // if(newTagData && newTagData.definition && newTagData.definition.id === 61){
      //   if( )
      // }
        return{
          ...state,
          authUser: newAuthUser
        }
      }

      /***********************************
       * FETCH_USER_DATA FOR USERS
       ***********************************/

    case FETCH_AUTH_USER_DATA: {
      return {
        ...state,
        loadingAuthUser: true,
      }
    }

    case FETCH_AUTH_USER_DATA_SUCCESS: {

      const newUserData = action.payload.inboundData;

      console.log("Updating authUser with FETCH_USER_DATA_SUCCESS", newUserData);

      //update the localStorage with this new authUser
      createLocalUserData(newUserData);

      return {
        ...state,
        authUser: newUserData,
        hasGetUserBeenCalledAtLeastOnce: true,
        loadingAuthUser: false,
      }
    }

    case FETCH_AUTH_USER_DATA_FAIL: {
      return {
        ...state,
        loadingAuthUser: false,
      }
    }

    //   /***********************************
    //    * FETCH_SUBSCRIPTION
    //    ***********************************/
    //
    // case FETCH_BR_SUBSCRIPTION: {
    //   return{
    //     ...state,
    //     loadingSubscriptions: true,
    //     errorLoadingSubscriptions: false,
    //   }
    // }
    //
    // case FETCH_BR_SUBSCRIPTION_SUCCESS: {
    //
    //   const customerId = action.payload.customerId;
    //   const newSubscriptionsObj = action.payload.inboundData && action.payload.inboundData.subscriptions;
    //
    //   const customersArray = state && state.authUser && state.authUser.customers
    //       ? state.authUser.customers
    //       : [];
    //
    //   const indexOfCustomerObjToUpdate = customersArray.findIndex((customer)=>customer.customer === customerId);
    //
    //   const oldCustomerObj = customersArray[indexOfCustomerObjToUpdate];
    //
    //   const updatedCustomerObj = {
    //     ...oldCustomerObj,
    //     subscriptions: newSubscriptionsObj,
    //   }
    //
    //   customersArray[indexOfCustomerObjToUpdate] = updatedCustomerObj;
    //
    //   console.log("FetchBRSubsriptoinSuccess looks like", "customersId", customerId, "NewsubscriptionOb", newSubscriptionsObj, "customersArray", customersArray,
    //       "indexofcustomersobjtoudpate", indexOfCustomerObjToUpdate, "oldCustomsersOb", oldCustomerObj, "updatedCustomersObj", updatedCustomerObj)
    //
    //   return{
    //     ...state,
    //     authUser: {
    //       ...state.authUser,
    //       customers: customersArray,
    //     },
    //     loadingSubscriptions: false,
    //     errorLoadingSubscriptions: false,
    //   }
    // }
    //
    // case FETCH_BR_SUBSCRIPTION_FAIL: {
    //  return{
    //    ...state,
    //    loadingSubscriptions: false,
    //    errorLoadingSubscriptions: true,
    //  };
    // }

      /***********************************
       * Add New User for self subscription without customer profile
       ***********************************/


    case ADD_NEW_USER_SELF_MANAGED: {
      return{
        ...state,
        loader: true,
        appMisc: {
          ...state.appMisc,
          didJustRegisterUser: false
        },
      }
    }

    case ADD_NEW_USER_SELF_MANAGED_SUCCESS: {
      return{
        ...state,
        loader: false,
        appMisc: {
          ...state.appMisc,
          didJustRegisterUser: true
        },
      }
    }

    case ADD_NEW_USER_SELF_MANAGED_FAIL: {
      return{
        ...state,
        loader: false,
        appMisc: {
          ...state.appMisc,
          didJustRegisterUser: false
        },
      }
    }

    case FETCH_NEW_COMPANY: {

      console.log("fETCH_NEW_COMPANY called --This is what the token looked like in the state when call was made ", state.token, "refreshToken", state.refreshToken);
      return{
        ...state,
        loadingFetchNewCompany: true,
      };
    }

    case FETCH_NEW_COMPANY_SUCCESS: {

      const inboundData = action.payload.inboundData;
      const entityObject = action.payload.inboundData.entity;
      const entityCanRegister = action.payload.inboundData.can_register;
      const error = action.payload.inboundData.error;

      console.log("FETCH NEW COMPANY SUCCESS", action.payload.inboundData, "entity", entityObject, "canRegister", entityCanRegister, "error", error)
      return{
        ...state,
        entityToConfirm: {
          ...inboundData
        },
        loadingFetchNewCompany: false,
        errorWithEntityToConfirm: false,
        // canRegister: entityCanRegister,
        // entityError: error,
      };
    }

    case FETCH_NEW_COMPANY_FAIL: {

      const inboundData = action.payload.inboundData;
      const canRegister = inboundData && inboundData.can_register;

      const reason = inboundData && inboundData.reason
          ? inboundData.reason
          : inboundData && inboundData.msg
              ? `${inboundData.msg}. Please sign in to continue registration.`
          : `Error confirming company information. Please try again. If the error persists, contact support@breachbits.com`;

      console.log("FETCH COMPNY FAIL", inboundData, )
      return {
        ...state,
        loadingFetchNewCompany: false,
        errorWithEntityToConfirm: true,
        errorMessage: !canRegister && reason,
      };
    }

    case ADD_NEW_COMPANY: {

      // const inboundData = action.payload.inboundData;
      // const newCustomer = action.payload.customer;
      // const newAccessToken = action.payload.access_token;
      // const newRefreshToken = action.payload.refresh_token;

      return {
        ...state,
        loadingAddNewCustomer: true,
        errorLoadingAddNewCustomer: false,
      }
    }

    case ADD_NEW_COMPANY_SUCCESS: {

      const inboundData = action.payload.inboundData;
      const newCustomer = action.payload.customer;
      const newAccessToken = action.payload.access_token;
      const newRefreshToken = action.payload.refresh_token;

      const customersArray = state
          && state.authUser
          && state.authUser.customers
          && Array.isArray(state.authUser.customers)
          && state.authUser.customers;

      console.log("Add_New_Company_Succes, log everything-- inboudnData", inboundData, "newCustomer", customersArray, "newCustomer", newCustomer, "newtokens", newAccessToken, "new refresh token", newRefreshToken)

      return {
        ...state,
        token: newAccessToken,
        refreshToken: newRefreshToken,
        loadingAddNewCustomer: false,
        errorLoadingAddNewCustomer: false,
        authUser: {
          ...state.authUser,
          customers: customersArray.push(newCustomer),
        },
        appMisc: {
          ...state.appMisc,
          didJustRegisterCompany: true,
        }
      }
    }

    case ADD_NEW_COMPANY_FAIL: {

      // const inboundData = action.payload.inboundData;

      return {
        ...state,
        loadingAddNewCustomer: false,
        errorLoadingAddNewCustomer: true,
        appMisc: {
          ...state.appMisc,
          didJustRegisterCompany: false,
        }

      }
    }
      /***********************************
       * START PRODUCT TOUR INDEPENDENT OF TAGS & STATUS
       ***********************************/

    case INITIATE_PRODUCT_TOUR_FOR_PAGE: {

      const url = action.payload

      console.log("initiating an update to non-persistent local state to launch tour for page", action, action.payload, url)


      //TODO: since this doesn't go through sagas(where the success/fail cases would be called), need to add a try/catch/error fall back
      return{
        ...state,
        // loadingStartProductTour: true,
        startProductTour: url,
        startProductTourError: false,
      }
    }

    case INITIATE_PRODUCT_TOUR_FOR_PAGE_SUCCESS: {
      const url = action.payload

      console.log("should store the url for the page to launch the tour on", url, "state is", state)

      return{
        ...state,
        loadingStartProductTour: false,
        startProductTour: url,
        startProductTourError: false,
      }
    }

    case INITIATE_PRODUCT_TOUR_FOR_PAGE_FAIL: {

      console.log("Error intitiating tour. state is", state)
      return{
        ...state,
        loadingStartProductTour: false,
        startProductTour: null,
        startProductTourError: true,
      }
    }

    default:
      return state;
    }
}
